var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 36.563,
    viewBox: "0 0 45 36.563",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1da1f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4397",
    "data-name": "Path 4397",
    className: "cls-1",
    d: "M40.342-21.328A20.286,20.286,0,0,0,45-26.162a19.824,19.824,0,0,1-5.273,1.494,9.159,9.159,0,0,0,4.043-5.1,18.776,18.776,0,0,1-5.889,2.2,10.438,10.438,0,0,0-3.032-2.109,8.8,8.8,0,0,0-3.735-.791,8.914,8.914,0,0,0-4.57,1.23,9.032,9.032,0,0,0-3.34,3.384,9.15,9.15,0,0,0-1.23,4.614,12.81,12.81,0,0,0,.176,2.109,25.546,25.546,0,0,1-10.591-2.812A25.448,25.448,0,0,1,3.164-28.8a8.835,8.835,0,0,0-1.318,4.614,8.865,8.865,0,0,0,1.143,4.438,10.238,10.238,0,0,0,2.988,3.34,8.688,8.688,0,0,1-4.131-1.23v.176a8.848,8.848,0,0,0,2.109,5.8A9.3,9.3,0,0,0,9.229-8.408a11.715,11.715,0,0,1-2.461.264q-.791,0-1.67-.088A9.178,9.178,0,0,0,8.306-3.706a8.585,8.585,0,0,0,5.405,1.8A18.3,18.3,0,0,1,2.2,2.051q-1.23,0-2.2-.088A25.606,25.606,0,0,0,14.15,6.094,25.357,25.357,0,0,0,28.477,1.963a25.1,25.1,0,0,0,8.877-9.932A26.061,26.061,0,0,0,40.43-20.186,5.236,5.236,0,0,0,40.342-21.328Z",
    transform: "translate(0 30.469)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.ecbf4eae0cae33a2056896302ca7ec0d.svg";